import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { logError } from '@zg-rentals/log-error';
import { useRentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import type { Route } from 'nextjs-routes';

const FEED_LISTING_ID_PATTERN = /^(\d|[a-zA-Z]|-)+_(\d|[a-zA-Z]|-)+$/;

export const useFeedListingIdRedirect = (listingAlias: string) => {
  const router = useRouter();
  const isFeedListingId = Boolean(listingAlias) && FEED_LISTING_ID_PATTERN.test(listingAlias);

  const { data: realAlias } =
    useRentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId(
      { listingId: listingAlias, originalUrl: typeof window !== 'undefined' ? window.location.pathname : undefined },
      {
        enabled: isFeedListingId,
        meta: {
          tags: ['feedListingIdAlias'],
          context: { api: 'rental-manager', details: 'getListingAliasForListingId' },
        },
      },
    );

  useEffect(() => {
    if (!realAlias || realAlias === listingAlias) return;

    logError({
      error: 'feedListingId detected in URL',
      errorType: 'feedListingIdDetected',
      context: { listingAlias, realAlias, referrer: document.referrer },
    });

    router.replace({
      pathname: router.pathname as Route['pathname'],
      query: { ...router.query, listingAlias: realAlias },
    });
  }, [realAlias, listingAlias, router]);
};
